export default __webpack_public_path__ + "media/zurb/img/events/rsvp/event-rsvp-time-icon-45667a94f57409975529c08902d8dda2.svg";